import { render, staticRenderFns } from "./ExportDynamicColumns.vue?vue&type=template&id=1826012d"
import script from "./ExportDynamicColumns.vue?vue&type=script&lang=js"
export * from "./ExportDynamicColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports